"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ProcessListItemHeader_1 = __importDefault(require("./ProcessListItemHeader"));
exports.default = ProcessListItemHeader_1.default;
